'use strict';

var _ = require('lodash');
var PricingSummarySnapshotDatesTransformerFactory = function PricingSummarySnapshotDatesTransformerFactory(DataTransformer, momentService, hepService) {
  var runFrequency = hepService.getSimpleHepProperty('DYNAMIC_PRICING_RECOM_FREQUENCY');
  function PricingSummarySnapshotDatesTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'pricing-summary-snapshot-dates';
    this.targetType = 'pricing-summary-snapshot-dates';
  }
  PricingSummarySnapshotDatesTransformer.prototype = Object.create(DataTransformer.prototype);
  PricingSummarySnapshotDatesTransformer.constructor = PricingSummarySnapshotDatesTransformer;
  PricingSummarySnapshotDatesTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  PricingSummarySnapshotDatesTransformer.prototype.isCacheable = function () {
    return false;
  };
  PricingSummarySnapshotDatesTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  function flattenByMarketPosCabin(data) {
    var result = [];
    for (var i = 0; i < data.length; i++) {
      for (var j = 0; j < data[i].marketPosCabin.length; j++) {
        var marketDateSummary = data[i];
        var marketCabinPosSummary = marketDateSummary.marketPosCabin[j];
        var runNumber;
        /*
        when frequency is set to 1 - treat all received data as being from the same "run" - this was we can still aggregate by runNumber in charts and grids
         */
        if (runFrequency > 1) {
          runNumber = marketDateSummary.runNumber;
        } else {
          var runNumberDate = marketDateSummary.optimizationDate.replaceAll('-', '');
          runNumber = runNumberDate + '1';
        }
        result.push({
          market: marketDateSummary.market,
          cabin: marketCabinPosSummary.cabinCode,
          pos: marketCabinPosSummary.pos,
          direction: marketCabinPosSummary.direction,
          optimizationDate: momentService.of(marketDateSummary.optimizationDate, momentService.FIELD.PRICING_SUMMARY_OPTIMIZATION_DATE),
          totalFareChange: marketCabinPosSummary.totalFareChange,
          effectedServicesYTD: marketCabinPosSummary.effectedServicesYTD,
          numberOfEffectedServices: marketCabinPosSummary.numberOfEffectedServices,
          numberOfExcludedServices: marketCabinPosSummary.numberOfEffectedServicesExcluded,
          numberOfExtendedServices: marketCabinPosSummary.numberOfEffectedServicesExtensions,
          runNumber: runNumber
        });
      }
    }
    return result;
  }
  PricingSummarySnapshotDatesTransformer.prototype.transform = function (snapshotData) {
    var data = _.get(snapshotData, 'domain.priceRecommendationSummaries', []);
    return flattenByMarketPosCabin(data);
  };
  return PricingSummarySnapshotDatesTransformer;
};
PricingSummarySnapshotDatesTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', 'HepService'];
module.exports = PricingSummarySnapshotDatesTransformerFactory;